import { createStore } from '../_core/createStore';
import { lazyDependency } from '../_core/lazyDependency';
import useApiStore from '../apiStore/useApiStore';
import { vehicleConfirmationStore } from './vehicleConfirmationStore';

const useVehicleConfirmationStore = createStore({
  creator: vehicleConfirmationStore({
    useApiStore: lazyDependency(() => useApiStore),
  }),
  id: 'vehicleConfirmation',
  middlewares: {
    devtools: true,
  },
});

export default useVehicleConfirmationStore;
